/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} L7_HoursInputs */

const es_l7_hours = /** @type {(inputs: L7_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De lunes a domingo · A la hora que te venga mejor`)
};

const gl_l7_hours = /** @type {(inputs: L7_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De luns a domingo · Á hora que che conveña`)
};

const en_l7_hours = /** @type {(inputs: L7_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monday to Sunday · Whenever suits you`)
};

/**
* | output |
* | --- |
* | "Monday to Sunday · Whenever suits you" |
*
* @param {L7_HoursInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const l7_hours = /** @type {((inputs?: L7_HoursInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<L7_HoursInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_l7_hours(inputs)
	if (locale === "en") return en_l7_hours(inputs)
	return es_l7_hours(inputs)
});